import { service } from './base-service'

const getClients = () => {
  return service.get('/centraldemarco/get-clients')
}

const getUnits = (clientName) => {
  if (!clientName) {
    throw new Error('clientName is required!')
  }
  return service.get(`/centraldemarco/get-units/${clientName}`)
}

const getSuperiorHierarchyByUnity = (units, unit) => {
  const unity = units.find(({ Id }) => Id === unit)
  const splitedCode = unity.Codigo.split('.')
  const codes = []
  codes.push(`${splitedCode[0]}.`)
  let i = 1
  while (i < splitedCode.length - 1) {
    const code = `${codes[i - 1]}${splitedCode[i]}.`
    codes.push(code)
    i++
  }
  const hierarchy = units
    .filter((unity) => codes.includes(unity.Codigo))
    .map((unity) => unity.Nome)
    .join(' - ')
  return hierarchy
}

const getChildren = (code, codes) => {
  return codes.filter(
    (codeF) =>
      codeF.includes(code) && codeF.split('.').length > code.split('.').length
  )
}

const isChildren = (code1, code2) => {
  return code1.split('.').length + 1 === code2.split('.').length
}

const getParent = (code, codes) => {
  return codes
    .filter(
      (codeF) =>
        code.includes(codeF) && codeF.split('.').length < code.split('.').length
    )
    .slice(-1)
}
const getUnitsHierarchyByCode = (units, userUnits) => {
  const codes = units
    .filter((unit) => userUnits.includes(unit.Id))
    .map((unit) => unit.Codigo)
    .sort()
  const codesHierarchy = []
  codes.forEach((code) => {
    const objectCode = {}
    objectCode.codigo = code
    objectCode.Filhas = getChildren(code, codes).filter((possibleChildren) =>
      isChildren(code, possibleChildren)
    )
    objectCode.Parent = getParent(code, codes)[0] || null
    codesHierarchy.push(objectCode)
  })
  return codesHierarchy
}
const getUnitsHierarchyByUserHierarchy = (units, userUnits) => {
  const list = getUnitsHierarchyByCode(units, userUnits)
  var map = {}
  var node
  var roots = []
  var i
  for (i = 0; i < list.length; i += 1) {
    map[list[i].codigo] = i
    list[i].Filhas = []
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i]
    if (node.Parent !== null) {
      node = units.find((unit) => unit.Codigo === node.codigo)
      node.Filhas = list[i].Filhas
      node.Parent = list[i].Parent
      list[map[node.Parent]].Filhas.push(node)
    } else {
      node = units.find((unit) => unit.Codigo === node.codigo)
      node.Filhas = list[i].Filhas
      roots.push(node)
    }
  }
  return roots
}

const saveUser = (id, user, locale, config = {}) => {
  if (id) {
    return service.put(`/centraldemarco/update-user/${id}`, {
      user: {
        ...user
      },
      locale
    }, config)
  }
  return service.post(`/centraldemarco/save-user`, {
    user: {
      ...user
    },
    locale
  }, config)
}

const parseCentralDemarcoError = (error) => {
  const data = error?.response?.data
  if (!data?.errors?.length) {
    return []
  }

  return data.errors
}

const activateOrInativateUser = (id, locale, active) => {
  const user = this.getUser(id)
  user.Active = active
  return this.saveUser(id, user, locale)
}

const getUser = (userId) => {
  if (!userId) {
    throw new Error('User Id is required!')
  }
  return service.get(`/centraldemarco/get-user/${userId}`)
}

const getUserByEmail = (email) => {
  if (!email) {
    throw new Error('Email is required!')
  }
  return service.get(`/centraldemarco/get-user-by-email/${email}`)
}

const getUsers = (clientName) => {
  if (!clientName) {
    throw new Error('clientName is required!')
  }
  return service.get(`/centraldemarco/get-user-by-client$/${clientName}`)
}

const getRecoveryPasswordLink = async (email) => {
  if (!email) {
    throw new Error('Email is required')
  }

  return await service.post(
    `/centraldemarco/get-recovery-password-link/${email}`
  )
}

const parseUnityToString = (units) => {
  if (units) {
    const formattedUnit = units.map(({ Id }) => Id).join(',')
    return formattedUnit.replace(/,\s*$/, '')
  }
  return ''
}

const parseUser = (name) => {
  const formattedName = name.split(' ')
  return formattedName[0] + '.' + formattedName[formattedName.length - 1]
}

export {
  getClients,
  getUnitsHierarchyByUserHierarchy,
  getUnits,
  getSuperiorHierarchyByUnity,
  saveUser,
  getUser,
  getUserByEmail,
  getUsers,
  getRecoveryPasswordLink,
  parseUnityToString,
  parseUser,
  activateOrInativateUser,
  parseCentralDemarcoError
}
